import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router';
import { timesheetSorter } from '../utils/sorting';
import DurationFormatter from '../utils/duration';
import * as list from '../utils/list';

import { modalDidMount, modalWillUnmount } from './ModalFixMixin';

import timesheetActions from '../actions/timesheetActionCreators';
import Time from "../utils/time";

class WeekModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        let timesheets = this.props.timesheets.sort(timesheetSorter);

        this.state = {
            timesheets: timesheets
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => { modalDidMount(); }

    componentWillReceiveProps = (nextProps) => {
        let timesheets = nextProps.timesheets.sort(timesheetSorter);

        this.setState({ timesheets: timesheets });
    }

    componentWillUnmount = () => { modalWillUnmount(); }

    // EVENT HANDLERS

    handleClose = () => {
        this.props.handleClose();
        if (this.state.deleted) this.props.handleReload();
    }

    handleDeleteTimesheet = (key) => {
        this.props.dispatch(timesheetActions.delete(this.state.timesheets[key].id));

        this.setState({
            timesheets: list.remove(this.state.timesheets, key)
        });
    }

    // RENDER METHOD

    render = () => {
        return (
            <Modal show={true} className="modal fade timesheets" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div className="modal-dialog new-floating timesheets" >
                <div className="modal-content timesheets">
                    <div className="modal-header timesheets">
                        <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title" id="myModalLabel">{this.props.title}</h4>
                        <h4 className="modal-title" id="myModalLabel">{this.props.subtitle}</h4>
                    </div>
                    <div className="modal-body timesheets scrollable-div" style={{"maxHeight" : "400px"}}>
                    <table className="table table-condensed project-people">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th className="text-center">Draft</th>
                                <th className="text-center">Submitted</th>
                                <th className="text-center">Rejected</th>
                                <th className="text-center">Accepted</th>
                                <th className="text-center">Total</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.timesheets.map((timesheet, key) => {
                              let week = timesheet.week + '';
                              try {
                                const year = parseInt(week.substring(0, 4), 10);
                                const weekNum = parseInt(week.substring(4, 6), 10);
                                const weeksTotal = Time.getISOWeeks(year);

                                if (weekNum > weeksTotal) {
                                  week = (year + 1) + '01';
                                }
                              } catch (error) {
                                console.error("An error occurred:", error);
                              }
                                let userID = timesheet.userID;
                                return (
                                    <tr key={key} id={key}>
                                        <td><Link to={{ pathname: '/editLogs', query: { week: week, userID: userID } }} >{timesheet.usersName}</Link></td>
                                        <td className="text-center">{timesheet.status === "ENTRY" ? DurationFormatter.format(timesheet.duration) : "0h"}</td>
                                        <td className="text-center">{timesheet.status === "SUBMITTED" ? DurationFormatter.format(timesheet.duration) : "0h"}</td>
                                        <td className="text-center">{timesheet.status === "REJECTED" || timesheet.status === "FIXING" ? DurationFormatter.format(timesheet.duration) : "0h"}</td>
                                        <td className="text-center">{timesheet.status === "APPROVED" ? DurationFormatter.format(timesheet.duration) : "0h"}</td>
                                        <td className="text-center">{DurationFormatter.format(timesheet.duration)}</td>
                                        <td>
                                            {
                                                timesheet.deletable ?
                                                <button title="Delete timesheet" type="button" onClick={this.handleDeleteTimesheet.bind(this, key)} className="btn btn-danger" data-dismiss="modal">Delete</button>
                                                :
                                                null
                                            }
                                        </td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                    </div>
                    <div className="modal-footer" >
                        <button title="Cancel and close dialog" type="button"  data-dismiss="modal" onClick={this.handleClose} className="btn btn-default btn-discrete" >Close</button>
                    </div>
                </div>
            </div>
            </Modal>
        );
    }
}

WeekModal.propTypes = {
    dispatch: PropTypes.func,
    handleReload: PropTypes.func,
    handleClose: PropTypes.func,
    subtitle: PropTypes.string,
    timesheets: PropTypes.array,
    title: PropTypes.string
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WeekModal);



/** WEBPACK FOOTER **
 ** ./src/app/components/WeekModal.js
 **/